import sectionCardCompareProductCss from '../css-snippets/section-card-compare-product';

const html = `
<style>${sectionCardCompareProductCss}</style>
<div
  class="card-compare-product-wrapper"
  data-attribute="card-compare-product-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-bad-position="right"
  data-container-full-width="false"
  style="
    --background-color: #f7eee7;
    --text-color: #000000;
    --good-bg-color: #4dc61c;
    --good-text-color: #ffffff;
    --bad-bg-color: #f3f3f3;
    --bad-text-color: #000000;
    --vs-bg-color: #121212;
    --vs-text-color: #ffffff;
  "
>
  <div
    class="card-compare-product-container-wrapper container"
    data-attribute="card-compare-product-wrapper"
  >
    <div
      class="card-compare-product-title"
      data-attribute="card-compare-product-title"
    >
      <h2 style="text-align: center">
        <strong
          >Dog Owners who Switch to FurSure&nbsp;<br />Never Go Back</strong
        >
      </h2>
    </div>
    <div
      class="card-compare-product-container"
      data-attribute="card-compare-product-container"
    >
      <div
        class="card-compare-product-images"
        data-attribute="card-compare-product-images"
      >
        <div
          class="card-compare-product-image-left"
          data-attribute="card-compare-product-image-left"
        >
          <img
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0d76f3464548e6dbedd0a.webp?w=1000"
            alt=""
          />
        </div>
        <div
          class="card-compare-product-image-text"
          data-attribute="card-compare-product-image-text"
        >
          VS.
        </div>
        <div
          class="card-compare-product-image-right"
          data-attribute="card-compare-product-image-right"
        >
          <img
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0d776647818714c5c09cf.webp?w=1000"
            alt=""
          />
        </div>
      </div>
      <div
        class="card-compare-functionality-list"
        data-attribute="card-compare-functionality-list"
      >
        <div
          class="card-compare-functionality-item"
          data-attribute="card-compare-functionality-item"
        >
          <div class="card-compare-functionality-good">
            <div
              class="card-compare-functionality-good-text"
              data-attribute="card-compare-functionality-good-text"
            >
              REPELS BEFORE BITE
            </div>
            <div
              class="card-compare-functionality-good-icon"
              data-attribute="card-compare-functionality-good-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
          </div>

          <div class="card-compare-functionality-bad">
            <div
              class="card-compare-functionality-bad-icon"
              data-attribute="card-compare-functionality-bad-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
            <div
              class="card-compare-functionality-bad-text"
              data-attribute="card-compare-functionality-bad-text"
            >
              KILLS AFTER BITE
            </div>
          </div>
        </div>

        <div
          class="card-compare-functionality-item"
          data-attribute="card-compare-functionality-item"
        >
          <div class="card-compare-functionality-good">
            <div
              class="card-compare-functionality-good-text"
              data-attribute="card-compare-functionality-good-text"
            >
              100% NATURAL OILS
            </div>
            <div
              class="card-compare-functionality-good-icon"
              data-attribute="card-compare-functionality-good-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
          </div>

          <div class="card-compare-functionality-bad">
            <div
              class="card-compare-functionality-bad-icon"
              data-attribute="card-compare-functionality-bad-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
            <div
              class="card-compare-functionality-bad-text"
              data-attribute="card-compare-functionality-bad-text"
            >
              HARSH CHEMICALS
            </div>
          </div>
        </div>

        <div
          class="card-compare-functionality-item"
          data-attribute="card-compare-functionality-item"
        >
          <div class="card-compare-functionality-good">
            <div
              class="card-compare-functionality-good-text"
              data-attribute="card-compare-functionality-good-text"
            >
              LASTS 12 MONTHS
            </div>
            <div
              class="card-compare-functionality-good-icon"
              data-attribute="card-compare-functionality-good-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
          </div>

          <div class="card-compare-functionality-bad">
            <div
              class="card-compare-functionality-bad-icon"
              data-attribute="card-compare-functionality-bad-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
            <div
              class="card-compare-functionality-bad-text"
              data-attribute="card-compare-functionality-bad-text"
            >
              LASTS 1 MONTH
            </div>
          </div>
        </div>

        <div
          class="card-compare-functionality-item"
          data-attribute="card-compare-functionality-item"
        >
          <div class="card-compare-functionality-good">
            <div
              class="card-compare-functionality-good-text"
              data-attribute="card-compare-functionality-good-text"
            >
              NO SIDE EFFECTS
            </div>
            <div
              class="card-compare-functionality-good-icon"
              data-attribute="card-compare-functionality-good-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
          </div>

          <div class="card-compare-functionality-bad">
            <div
              class="card-compare-functionality-bad-icon"
              data-attribute="card-compare-functionality-bad-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
            <div
              class="card-compare-functionality-bad-text"
              data-attribute="card-compare-functionality-bad-text"
            >
              MANY HEALTH RISKS
            </div>
          </div>
        </div>

        <div
          class="card-compare-functionality-item"
          data-attribute="card-compare-functionality-item"
        >
          <div class="card-compare-functionality-good">
            <div
              class="card-compare-functionality-good-text"
              data-attribute="card-compare-functionality-good-text"
            >
              TAKES 10 SECONDS
            </div>
            <div
              class="card-compare-functionality-good-icon"
              data-attribute="card-compare-functionality-good-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
          </div>

          <div class="card-compare-functionality-bad">
            <div
              class="card-compare-functionality-bad-icon"
              data-attribute="card-compare-functionality-bad-icon"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z"
                  fill="#121212"
                ></path>
              </svg>
            </div>
            <div
              class="card-compare-functionality-bad-text"
              data-attribute="card-compare-functionality-bad-text"
            >
              HASSLE TO APPLY
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
